export default "__VITE_ASSET__Cacjzj5c__"